const StatusCell = ({ status }) => {
    const statusClassNames = {
        active: 'badge-success',
        inactive: 'badge-secondary',
        published: 'badge-success',
        draft: 'badge-secondary'
    }

    return (
        <span className={"text-capitalize badge " + statusClassNames[status]}>{status}</span>
    )
}

export default StatusCell